<button type="button" class="btn btn-primary" (click)="open()">Choose a Saved Contact</button>
<p-dialog header="Choose a Saved Contact" [(visible)]="show" [modal]="true">
    <iui-messages #message class="ms-auto me-auto"></iui-messages>

    Choose one of your saved contacts from the list below.
    To update a saved contact, select it and click the Update button.
    The Primary Account Contact or Billing Account Contact can be updated on the Edit Account page.
    The CSC Registrant Address can be updated on the My Profile page.
    If you'd like to add a new contact, click the Add button.
    <div class="py-2"></div>
    <div *ngFor="let address of addressBook; let i = index">
        <p-radioButton [value]="address" [(ngModel)]="selection"></p-radioButton>&nbsp;
        <strong>{{ address.label }}:</strong>
        {{ addressText(address) }}
    </div>
    <p-footer>
        <button type="button" class="btn btn-primary" [disabled]="!selection" (click)="choose()">Choose</button>
        <button type="button" class="btn btn-primary" (click)="addAddress()">Add</button>
        <button type="button" class="btn btn-primary" [disabled]="!selection || !selection.addressBookId"
            (click)="updateAddress()">Update</button>
        <button type="button" class="btn btn-primary" [disabled]="!selection || !selection.addressBookId"
            (click)="deleteAddress()">Delete</button>
        <button type="button" class="btn btn-secondary" (click)="show=false">Cancel</button>
    </p-footer>
</p-dialog>

<p-dialog [header]="address.addressBookId ? 'Update Contact' : 'Add Contact'" [(visible)]="update" [modal]="true">

    <form #form="ngForm" (keydown.enter)="handleEnter($event)" class="mx-3" [ngClass]="{ presubmit: !submitted }">
        <div class="pt-2">
            <label for='ab-addressName' class="required">Address Name</label>
            <input appScrText required id='ab-addressName' name="label" [(ngModel)]="address.label" #addressName="ngModel"
                placeholder="Address Name" />
            <app-error-msg [field]="addressName" fieldLabel="Address Name"></app-error-msg>
        </div>
        <div class="pt-2">
            <label for='ab-firstName' class="required">First Name</label>
            <input appScrText required appFirstNameValidator name="firstName" id='ab-firstName' [(ngModel)]="address.firstName"
                #firstName="ngModel" placeholder="First Name" />
            <app-error-msg [field]="firstName" fieldLabel="First Name"></app-error-msg>
        </div>
        <div class="pt-2">
            <label for='ab-lastName' class="required">Last Name</label>
            <input appScrText required appLastNameValidator name="lastName" id='ab-lastName' [(ngModel)]="address.lastName"
                #lastName="ngModel" placeholder="Last Name" />
            <app-error-msg [field]="lastName" fieldLabel="Last Name"></app-error-msg>
        </div>
        <div class="row mx-0 pt-2">
            <div class="col-4 ps-0">
                <label for="ab-phoneInput" class="required">Phone Number</label>
                <app-phone [(ngModel)]="address.phone" #phone="ngModel" class="col-12" name="phone" required id="ab-phone"></app-phone>
                <app-error-msg [field]="phone" fieldLabel="Phone Number"></app-error-msg>
            </div>
            <div class="col-4">
                <label for="ab-ext">Extension</label>
                <input appScrText id='ab-ext' name="ext" [(ngModel)]="address.phoneExtension" maxlength="6" placeholder="Ext" />
            </div>
        </div>
        <div class="pt-2">
            <label for="ab-email" class="required">Email</label>
            <input appScrText appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" id='ab-email' required name="email" maxlength="{{MaxLen.Email}}"
                [(ngModel)]="address.email" #email="ngModel" placeholder="Email" />
            <app-error-msg [field]="email" fieldLabel="Email"></app-error-msg>
        </div>
        <div class="pt-2">
            <label for="ab-company">Organization Name</label>
            <input appScrText name="company" id='ab-company' [(ngModel)]="address.company" #company="ngModel" placeholder="Organization Name" />
            <app-error-msg [field]="company" fieldLabel="Organization Name"></app-error-msg>
        </div>
        <div class="pt-2">
            <label for="ab-country">Country</label>
            <app-country-dropdown [optional]="true" id='ab-country' name="country" [(ngModel)]="address.country"></app-country-dropdown>
        </div>
        <div class="pt-2">
            <label for="ab-address1">Street Address 1</label>
            <input appScrText id='ab-address1' name="address1" [(ngModel)]="address.address1" placeholder="Street Address 1" />
        </div>
        <div class="pt-2">
            <label for="ab-address2">Street Address 2</label>
            <input appScrText id='ab-address2' name="address2" [(ngModel)]="address.address2" placeholder="Street Address 2" />
        </div>
        <div class="pt-2">
            <label for="ab-city">City</label>
            <input appScrText id='ab-city' name="city" [(ngModel)]="address.city" placeholder="City" />
        </div>
        <div class="pt-2">
            <label for="ab-state">State/Province</label>
            <app-region-dropdown [optional]="true" id='ab-state' name="state" appTid [(ngModel)]="address.state" #state="ngModel"
                [country]="address.country"></app-region-dropdown>
            <app-error-msg [field]="state" fieldLabel="State/Province"></app-error-msg>
        </div>
        <div class="pt-2">
            <label for="ab-zip">Zip/Postal Code</label>
            <app-zipcode-input [optional]="true" inputId='ab-zip' name="zip" [(ngModel)]="address.zip" #zip="ngModel"
                [country]="address.country"></app-zipcode-input>
            <app-error-msg [field]="zip" fieldLabel="Zip/Postal Code"></app-error-msg>
        </div>
    </form>

    <p-footer>
        <button type="button" class="btn btn-primary" (click)="saveAddress()">
            {{ address.addressBookId ? 'Update' : 'Add' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="update=false; show=true;">
            Cancel
        </button>
    </p-footer>
</p-dialog>